import { Component, ViewChild, OnInit, Compiler, ElementRef } from '@angular/core';
import { first, retry } from 'rxjs/operators';
import { Pipe } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { NgbDatepickerConfig, NgbCalendar, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { AppConfig } from '../util';
import { Common } from '../util/common';
import { ExcelService } from '../service/excel.service';
import { CommonService } from '../service/commons-service';
import { Chart } from 'chart.js';


var cl = console.log;



@Component({
    templateUrl: 'intervention.component.html',
    styleUrls: ['intervention.component.css']
})
export class InterventionComponent implements OnInit {
    @ViewChild('tableCanvas', { read: ElementRef }) tableCanvas: ElementRef;
    users: any = {};
    loginImageURL: any = "";
    loginUserName: any = "";
    userList: any[] = [];
    updateUserSkillForm: FormGroup;
    interventionForm: FormGroup;
    isEnable: boolean = false;
    loading: boolean = false;
    baseURL: any = null;
    selectedUserId: any = "Select User";
    headders: any[] = ["Competency Graph", "Action"];
    sDate: any = null;
    eDate: any = null;
    resourceSkillsData: any[] = [];
    resourceBehSkillsData: any[] = [];
    removeUsersFromList: any[] = ["ct_reliance", "tc_lavoro", "tc_iqvia", "reco", "tw", "additonal", "recource", "resource", "boeing", "abb", "sap", "citi", "principal", "pb_resource", "lm_ra", "lm_resource", "keybank", "toyota", "csd"];
    chart: any[] = [];
    viewContent: any = null;
    totalMonth: any[] = [];
    selectedTab: any = 1;
    addChartData: any[] = [];
    skillArray: any[] = [{ skillId: 1, skillName: "StoryLine" }, { skillId: 2, skillName: "Lectora" }, { skillId: 3, skillName: "HTML" }];
    consolidatedChartData: any = null;
    consolidatedBehChartData: any = null;
    consolidatedTableData: any = null;
    consolidatedBehTableData: any = null;
    showHideModel: boolean = true;
    selectedStoryLine: any = "3_Beginner"
    selectedLectora: any = "3_Beginner"
    selectedHTML: any = "3_Beginner"
    userName: any = "";
    currentUserList: any[] = [];
    interventionList: any[] = [];
    usersInterventionList: any[] = [];
    config: any;
    skillId: any = "";
    interventionId: any = "";
    interventionLFeildList: FormArray;
    interventionFieldsArray: FormArray;
    userInterventionList: any[] = []
    startDate: any;
    selectedMonth: any = 0;
    towerId: any;
    skillData: any[] = [];
    skillBehData: any[] = [];
    skillRatingData: any[] = [];
    currentUserId: any;
    selectedPositionId: Number = 0;
    selectedCombinedId: any = 'Select User';
    clickedSkillId: any = 0;
    butDisabled: boolean = true;
    curRating: any = [];
    curRatingVal: any = '';
    ratingDataFunctional: any = [];
    ratingDataBehavioral: any = [];
    funClicked: boolean = false;
    behClicked: boolean = false;
    commonInterventionData: any = [];
    currentSkillIntervention: any = {};
    selectedTowerId: any;
    interventionFieldForm: FormGroup;

    constructor(private router: Router, private appConfig: AppConfig, private common: Common,
        private commonService: CommonService, config: NgbDatepickerConfig, private _compiler: Compiler,
        private formBuilder: FormBuilder, calendar: NgbCalendar, private excelService: ExcelService) {
        this.users = JSON.parse(localStorage.getItem('user'));
        if (!this.users || !this.users.userData) {
            this.commonService.logout();
            return;
        }
        if (this.users && this.users.userData) {
            this.loginImageURL = this.appConfig.getDefaultImgURL();
            this.loginUserName = this.users.userData.userFullName;
            this.towerId = this.users.userData.towerId;
        }
        this.baseURL = this.appConfig.getServerURL();
        this._compiler.clearCache();

        let currentDate = new Date();
        this.config = config;
        this.config.minDate = { year: currentDate.getFullYear(), month: (currentDate.getMonth()), day: currentDate.getDate() };
        this.config.maxDate = { year: 2099, month: 12, day: 31 };
        this.config.outsideDays = 'collapsed';

    }

    ngOnInit() {
        localStorage.setItem("selectedMonth", "3");
        this.updateUserSkillForm = this.formBuilder.group({
            selectedStoryLine: new FormControl(""),
            selectedLectora: new FormControl(""),
            selectedHTML: new FormControl(""),
            userName: new FormControl("")
        });

        this.interventionForm = this.formBuilder.group({
            userName: new FormControl(""),

            interventionFieldArray: this.formBuilder.array([this.createFields()])
        });

        this.getUsersList();
        this.fetchSkillsData();
        this.fetchBehSkillsData();
        this.fetchSkillRatingData();

        if (localStorage.getItem("selectedMonth") == "5") {

        }
    }

    //fetch functional skill master
    private fetchSkillsData() {
        this.commonService.fetchSkillDataPost(this.towerId).pipe(first()).subscribe(
            data => {
                this.skillData = data;
            },
            error => {
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
                localStorage.removeItem('errorMsg');
            }
        )
    }

    //fetch beh skill master
    private fetchBehSkillsData() {
        this.commonService.fetchBehSkillDataPost(this.towerId).pipe(first()).subscribe(
            data => {
                this.skillBehData = data;
            },
            error => {
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
                localStorage.removeItem('errorMsg');
            }
        )
    }

    // Get skillratingmaster: strength: 5, weakness: 1, etc
    private fetchSkillRatingData() {
        this.skillRatingData = [];
        this.commonService.fetchSkillRatingData().pipe(first()).subscribe(
            data => {
                if (data && data.length > 0) {
                    this.skillRatingData = data;
                } else {
                    localStorage.setItem('errorMsg', "Competency Rating Data Not Found");
                    this.commonService.showerror();
                    localStorage.removeItem('errorMsg');
                }
            },
            error => {
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
                localStorage.removeItem('errorMsg');
            }
        )
    }
    //initialized intervention form
    private initInterventionForm() {
        this.interventionForm = this.formBuilder.group({
            userName: new FormControl(""),

            interventionFieldArray: this.formBuilder.array([this.createFields()])
        });
    }

    //get intervention form group fields array.
    get interventionFormGroup() {

        return this.interventionForm.get('interventionFieldArray') as FormArray;
    }

     loadUserData(str) {
        if (!this.selectedCombinedId || this.selectedCombinedId == "Select User") {
            localStorage.setItem('errorMsg', "Please select user first!");
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
            return;
        }
        this.selectedUserId = this.selectedCombinedId.split("_")[0];
        this.selectedPositionId = this.selectedCombinedId.split("_")[1];
        this.selectedTowerId = this.selectedCombinedId.split("_")[2];

        if (!this.selectedUserId || this.selectedUserId == "Select User") {
            localStorage.setItem('errorMsg', "Please select user first!");
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
            return;
        }
        if (str === 'fun') {
            this.userFunSkillByTowerPosition();
        } else {
            this.userBehSkillByTowerPosition();
        }
        this.loading = true;
        let userIds = [Number(this.selectedUserId)];
        var userId: any = Number(this.selectedUserId);

        this.getInterventionList();
        this.getUsersInterventionList(str);
        let c = this.interventionFieldsArray = this.interventionForm.get('interventionFieldArray') as FormArray;
    }

    // create fields
    private createFields(): FormGroup {
        return this.interventionFieldForm = this.formBuilder.group({
            savedInterventionId: new FormControl(''),
            skillId: new FormControl(""),
            expectedLevel: new FormControl(""),
            actualLevel: new FormControl(""),
            interventionId: new FormControl(""), // i.e Email, Phone
            interventionStartDate: new FormControl(""), // i.e. Home, Office
            interventionEndDate: new FormControl("")
        });
    }
    /**
    * Convenience getter for easy access to form fields
    */
    get f() { return this.interventionFieldForm.controls; }

    // set fields value
    private setFields(skills): FormGroup {
        return this.formBuilder.group({
            skillId: new FormControl(skills.skillId),
            interventionId: new FormControl(skills.interventionId),
            interventionStartDate: new FormControl(this.common.getJSONObj(skills.interventionStartDate)), // i.e. Home, Office
            interventionEndDate: new FormControl(this.common.getJSONObj(skills.interventionEndDate))
        });
    }

    // /Get All Users information
    private getUsersList() {
        this.loading = true;
        var userEmail = "";
        if (JSON.parse(localStorage.getItem('user')).userData.userRoll == 4)
            userEmail = JSON.parse(localStorage.getItem('user')).userData.userEmail;

        this.commonService.getUsersListByPost(JSON.parse(localStorage.getItem('user')).userData.towerId, userEmail).pipe(first()).subscribe(
            data => {
                this.loading = false;
                if (data && data.length > 0) {
                    this.userList = data;
                    this.currentUserList = data;

                } else {
                    localStorage.setItem('errorMsg', "Users Not Found");
                    this.commonService.showerror();
                    localStorage.removeItem('errorMsg');
                }
            }, error => {
                this.loading = false;
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
                localStorage.removeItem('errorMsg');
            }
        )
    }

    // add a feilds form group
    private addFeilds() {
        this.interventionFieldsArray.push(this.createFields());
    }

    // remove feilds from group
    private removeFields(index) {
        
        this.interventionFieldsArray.removeAt(index);
    }

    // Get users list which are Available from current date.
    private getCurrentAvailableUsers() {
        this.currentUserList = [];
        this.loading = true;
        var userEmail = "";
        if (JSON.parse(localStorage.getItem('user')).userData.userRoll == 4)
            userEmail = JSON.parse(localStorage.getItem('user')).userData.userEmail;


        this.commonService.fetchUserData(null, this.towerId, userEmail).pipe(first()).subscribe(
            data => {
                this.currentUserList = data;
                this.loading = false;
            },
            error => {
                this.loading = false;
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
            })
    }

    // Get users list which are Available from current date.
    private getInterventionList(skillId?: any) {
        this.interventionList = [];
        this.loading = true;
        
        this.commonService.getInterventionList(skillId).pipe(first()).subscribe(
            data => {
                this.interventionList = data;
                this.loading = false;
            },
            error => {
                this.loading = false;
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
            })
    }

    // Get users intervention list
    private getUsersInterventionList(dataFor) {
        this.usersInterventionList = [];
        this.loading = true;
        this.commonService.getUsersInterventionList().pipe(first()).subscribe(
            data => {
                this.usersInterventionList = data;
                this.loading = false;
                if (localStorage.getItem("selectedMonth")) {
                    this.getStartAndEndDate(Number(localStorage.getItem("selectedMonth")), dataFor)
                }
            },
            error => {
                this.loading = false;
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
            })
    }

    //edit skills
    private onEditSubmit(userData, skillId) {
        this.clickedSkillId = skillId;
        this.curRatingVal = this.curRating[skillId];
        this.userName = this.getUserInfo(userData.userId).userName.trim();
        this.selectedStoryLine = this.getCurrentSkillLevel(userData.storyLineSkills);
        this.selectedLectora = this.getCurrentSkillLevel(userData.lectoraSkills);
        this.selectedHTML = this.getCurrentSkillLevel(userData.htmlSkills);

    }

    // Get current skill level
    // + Used when the popup is opened
    private getCurrentSkillLevel(skills) {

        let skillName = "";
        let beginner = "3_Beginner";
        let intermediate = "2_Intermediate";
        let expert = "1_Expert";
        let date = null;
        if (skills && skills.length > 0) {
            for (let i = 0; i < skills.length; i++) { 
                if (!date) {
                    if (skills[i].skillLevel == 0 || skills[i].skillLevel == 25) {
                        skillName = beginner;
                        date = new Date(skills[i].date);
                    } else if (skills[i].skillLevel == 50) {
                        skillName = intermediate;
                        date = new Date(skills[i].date);
                    } else {
                        skillName = expert;
                        date = new Date(skills[i].date);
                    }
                } else {
                    let tempDate = new Date(skills[i].date);
                    if (date < tempDate && skills[i].skillLevel == 0 || skills[i].skillLevel == 25) {
                        skillName = beginner;
                        date = new Date(skills[i].date);
                    } else if (date < tempDate && skills[i].skillLevel == 50) {
                        skillName = intermediate;
                        date = new Date(skills[i].date);
                    } else if (date < tempDate) {
                        skillName = expert;
                        date = new Date(skills[i].date);
                    }
                }
            }
        }
        return skillName;
    }

    //+ get the month (returns the selected month?)
    private getStartAndEndDate(numOfMonth, dataFor) {
        if (this.selectedUserId === "Select User") return;
        localStorage.setItem("selectedMonth", numOfMonth);
        this.totalMonth = [];
        this.addChartData = [];
        let lastDate = new Date();
        lastDate.setMonth(lastDate.getMonth() - numOfMonth);
        this.sDate = this.common.getDatesYYMMDD(lastDate);
        this.eDate = this.common.getDatesYYMMDD(new Date());
        this.totalMonth = this.common.getMonthsNameArray(lastDate, new Date());
        
        this.getResourcesSkillHistory(dataFor);
        this.getResourcesBehSkillHistory(dataFor);
        if (numOfMonth === 3) this.selectedTab = 1;
        else if (numOfMonth === 6) this.selectedTab = 2;
        else if (numOfMonth === 9) this.selectedTab = 3;
        else if (numOfMonth === 12) this.selectedTab = 4;

    }

    //get functional skill ratings for the user
    private getResourcesSkillHistory(str) {
        this.loading = true;
        this.resourceSkillsData = [];
        this.consolidatedChartData = [];
        this.consolidatedTableData = [];
        this.commonService.getResourcesSkillHistory(this.selectedUserId).pipe(first()).subscribe(
            data => {
                if (data[0] && data[0].length > 0) {
                    // remove unknown user from the list
                    this.ratingDataFunctional = data[0];
                    let usersInfo = this.filterUsers(data[0]);
                    this.resourceSkillsData = this.filterUsersSkills(usersInfo, "fun");
                    if (this.resourceSkillsData.length) {
                        setTimeout(() => {
                            this.getTableCanvas();
                        }, 500);
                    }
                    this.consolidatedChartData = this.getConsolidatedChart(this.resourceSkillsData);
                    this.consolidatedTableData = this.getConsolidatedTableData(this.resourceSkillsData);
                    this.isEnable = true;
                }
                else {
                    if (str == 'fun') {
                        localStorage.setItem('errorMsg', 'No Functional Ratings are available for this user.');
                        this.commonService.showerror();
                    }
                    this.loading = false;
                    return;
                }
                // this.loading = false;
            },
            error => {
                this.loading = false;
                localStorage.setItem('errorMsg', 'Data Not Found');
                this.commonService.showerror();
                return;
            });
    }

    //get behavioral skill ratings for the user
    private getResourcesBehSkillHistory(str) {
        this.loading = true;
        this.resourceSkillsData = [];
        this.consolidatedChartData = [];
        this.consolidatedTableData = [];
        this.commonService.getResourcesBehSkillHistory(this.selectedUserId).pipe(first()).subscribe(
            data => {
                if (data[0] && data[0].length > 0) {
                    // remove unknown user from the list
                    this.ratingDataBehavioral = data[0];
                    let usersInfo = this.filterUsers(data[0]);
                    this.resourceBehSkillsData = this.filterUsersSkills(usersInfo, "beh");
                    if (this.resourceBehSkillsData) {
                        setTimeout(() => {
                            this.getTableCanvas();
                        }, 500);
                    }
                    this.consolidatedBehChartData = this.getConsolidatedChart(this.resourceSkillsData);
                    this.consolidatedBehTableData = this.getConsolidatedTableData(this.resourceSkillsData);
                    // this.isEnable = true;
                }
                else {
                    if (str == 'beh') {
                        localStorage.setItem('errorMsg', 'No Behavioral Ratings are available for this user.');
                        this.commonService.showerror();
                    }
                    this.loading = false;
                    return;
                }
            },
            error => {
                this.loading = false;
                localStorage.setItem('errorMsg', 'Data Not Found');
                this.commonService.showerror();
                return;
            });
    }

    // + removes a specific set of users from the list
    private filterUsers(userInfodata) {
        let userInfoList = [];
        if (userInfodata && userInfodata.length > 0) {
            for (let i = 0; i < userInfodata.length; i++) {
                let isInvalidUser = false;
                for (let j = 0; j < this.removeUsersFromList.length; j++) {
                    if (userInfodata[i].userName) {
                        let userName = userInfodata[i].userName.toLowerCase();
                        if (userName.includes(this.removeUsersFromList[j])) {
                            isInvalidUser = true;
                            break;
                        }
                    }
                }
                if (!isInvalidUser) {
                    userInfoList.push(userInfodata[i]);
                }
            }
        }
        return userInfoList;
    }

    //filetr users skill levels
    private filterUsersSkills(userInfodata, type) {
        let userInfoList = [];
        let addedUsers = [];
        var skillData = (type === "beh") ? this.skillBehData : this.skillData;
        var prefix = (type === "beh") ? "b_" : "f_";

        if (userInfodata.length > 0) {
            for (let i = 0; i < userInfodata.length; i++) {
                let userSkillObj = [];
                
                if (!userInfodata[i].userId || userInfodata[i].userId != this.selectedUserId) {
                    continue;
                }
                let userId = userInfodata[i].userId;

                if (addedUsers.indexOf(userId) != -1) {
                    continue;
                }
                for (let j = 0; j < userInfodata.length; j++) {
                    if (userInfodata[j].userId) {
                        if (userId == userInfodata[j].userId) {
                            userSkillObj.push(userInfodata[j]);
                        }
                    }
                }
                addedUsers.push(userId);
                for (let j = 0; j < skillData.length; j++) {
                    userInfodata[i][skillData[j].skillName] = this.getUserSkillLevel(userSkillObj, skillData[j].skillId);
                    userInfodata[i][skillData[j].skillName + "InterData"] = this.filterUserInterventions(userInfodata[i].userId, prefix + skillData[j].skillId);
                }
                userInfoList.push(userInfodata[i]);
            }
        }

        return userInfoList;
    }

    //filetr users skill level
    private getUserSkillLevel(users, skillId) {
        let skillLevelData = [];
        if (users && users.length > 0) {
            let lastFoundSkillLevel = null;
            for (let i = 0; i < this.totalMonth.length; i++) {
                let skillObj = {};
                let foundRecord = false;
                for (let j = 0; j < users.length; j++) {
                    if (users[j].skillId != skillId) continue;

                    let skillDate = this.getDate(users[j]);
                    if (this.totalMonth[i] == skillDate && skillObj['date'] == skillDate) {
                        lastFoundSkillLevel = users[j].skillScore;
                        foundRecord = true;
                        skillObj['skillLevel'] = users[j].skillScore;// this.getSkillLeve(users[j].skillLevel);
                    } else if (this.totalMonth[i] == skillDate) {
                        foundRecord = true;
                        lastFoundSkillLevel = users[j].skillScore;
                        skillObj = { date: this.totalMonth[i], skillLevel: users[j].skillScore /* this.getSkillLeve(users[j].skillLevel) */ };
                    }
                }

                if (!foundRecord) {
                    if (lastFoundSkillLevel) {
                        skillLevelData.push(
                            {
                                date: this.totalMonth[i],
                                skillLevel: lastFoundSkillLevel //this.getSkillLeve(lastFoundSkillLevel) 
                            }
                        );
                    } else {
                        
                        skillLevelData.push(
                            {
                                date: this.totalMonth[i],
                                skillLevel: 0 //this.getSkillLeve(null) 
                            }
                        );
                    }
                } else {
                    skillLevelData.push(skillObj);
                }
            }
        }
        
        return skillLevelData;
    }

    // get intervention name by interventionId
    private filterUserInterventions(userName, skillId) {
        let interventionType = [];
        let userInfo = this.getUserInfo(userName);
        if (!userInfo || !userInfo.userId) {
            return
        }
        if (this.usersInterventionList && this.usersInterventionList.length > 0) {
            for (let i = 0; i < this.usersInterventionList.length; i++) {
                if (this.usersInterventionList[i].userId == userInfo.userId && this.usersInterventionList[i].skillId == skillId) {
                    let interDateArray = this.common.getMonthsNameArray(new Date(this.usersInterventionList[i].interventionStartDate), new Date(this.usersInterventionList[i].interventionEndDate));
                    for (let j = 0; j < interDateArray.length; j++) {
                        let index = this.getIndexFromArray(interventionType, interDateArray[j]);
                        if (index >= 0) {
                            interventionType[index] = {
                                date: interDateArray[j],
                                skillLevel: this.usersInterventionList[i].expectedLevel
                                
                            };
                        } else {
                            interventionType.push({
                                date: interDateArray[j],
                                skillLevel: this.usersInterventionList[i].expectedLevel
                                
                            });
                        }
                    }
                }
            }
            // matched data from selected date from intervention date
            let selectedDateArray = this.common.getMonthsNameArray(new Date(this.sDate), new Date(this.eDate));
            if (selectedDateArray && selectedDateArray.length > 0) {
                for (let i = 0; i < selectedDateArray.length; i++) {
                    let index = this.getIndexDateFromArray(interventionType, selectedDateArray[i]);
                    if (index == -1) {
                        interventionType.push({ date: selectedDateArray[i], skillLevel: 0 });
                    }
                }
            }
        }
        return interventionType;
    }

    // get indexof for exiting record. 
    private getIndexDateFromArray(array, checkWith) {
        let index = -1;
        if (array && array.length > 0 && checkWith) {
            for (let i = 0; i < array.length; i++) {
                if (array[i].date == checkWith) {
                    index = i;
                    break;
                }
            }
        }
        return index;
    }

    // get indexof for exiting record. 
    private getIndexFromArray(array, checkWith) {
        let index = -1;
        if (array && array.length > 0 && checkWith) {
            for (let i = 0; i < array.length; i++) {
                if (array[i].date == checkWith) {
                    index = i;
                    break;
                }
            }
        }
        return index;
    }

    private makeArrayForGraph(skillId, skillType) {

        var skillData;

        if (skillType === "beh") {
            skillData = this.ratingDataBehavioral;
        }
        else {
            skillData = this.ratingDataFunctional;
        }

        var currentYear = Number((new Date()).getFullYear());
        var currentMonth = Number((new Date()).getMonth() + 1);
        var ratings = [], pastYearRatings = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];


        for (let i = 0; i < skillData.length; i++) {
            if (skillData[i].positionId != this.selectedPositionId)
                continue;

            if (skillData[i].skillId == skillId) {

                var toMonth = new Date(skillData[i].skillRatingToDate).getMonth() + 1;
                

                var fromMonth = new Date(skillData[i].skillRatingFromDate).getMonth() + 1;
               

                for (let j = fromMonth; j <= toMonth; j++) {
                    
                    ratings[currentMonth - j] = skillData[i].skillScore;

                }

            }
        }



        let j = 0;

        for (let i = 12; i > 7; i--) {

            if (!ratings[j])
                pastYearRatings[i] = 0;
            else
                pastYearRatings[i] = ratings[j];
            j++;
        }

        


        return pastYearRatings;
    }

    private getDate(userInfo) {
        if (userInfo) {
            if (userInfo.createDate) {
                return this.common.getMonthsName(userInfo.createDate);
            }
        }
    }


    // get consolidateData of skill index
    private getConsolidatedChart(usersData) {
        let expert = {};
        if (usersData && usersData.length > 0) {
            for (let i = 0; i < usersData.length; i++) {
                for (let j = 0; j < this.skillData.length; j++) {
                    let skillName = this.skillData[j].skillName;
                    let skillObj = this.getSkillData(usersData[i][skillName]);
                    if (expert[skillName]) {
                        expert[skillName] = expert[skillName] + skillObj;
                    } else {
                        expert[skillName] = skillObj;
                    }
                }
            }
        }
        return expert;
    }

    // Get skill Data
    private getSkillData(skillData) {
        let count = 0;
        if (skillData && skillData.length > 0) {
            for (let i = 0; i < skillData.length; i++) {
                count = count + skillData[i].skillLevel;
            }
        }
        return count;
    }

    private getConsolidatedTableData(usersData) {  //not being used
        let skillObject = {}

        if (usersData && usersData.length > 0) {
            for (let i = 0; i < usersData.length; i++) {



                for (let k = 0; k < this.skillRatingData.length; k++) {
                    skillObject[k] = {};

                    var value = 100 * (k + 1) / this.skillRatingData.length;

                    for (let j = 0; j < this.skillData.length; j++) {
                        let skillName = this.skillData[j].skillName;
                        if (skillObject[k][skillName]) {
                            skillObject[k][skillName] = skillObject[k][skillName] + this.getSkillLevelData(usersData[i], skillName, value);
                        } else {
                            skillObject[k][skillName] = this.getSkillLevelData(usersData[i], skillName, value);
                        }
                    }

                }

            }
        }
        return skillObject;  //I doubt that it is being used
    }

    // Get skill Data
    private getSkillLevelData(userInfo, skillName, level) {
        let count = 0;
        if (userInfo) {
            let skillData = userInfo[skillName];
            for (let i = 0; i < skillData.length; i++) {
                if (skillData[i].skillLevel == level) {
                    count++;
                }
            }
        }
        return count;
    }

    private getSkillName(ratingId) {
        //get rating name by Id

        for (let i = 0; i < this.skillRatingData.length; i++) {
            if (this.skillRatingData[i].score == ratingId)
                return this.skillRatingData[i].ratingName;
        }
        
    }

    // Generate user skill Line Chart
    private generateChart(divId, userInfo, userInfoBeh) {
        
        if (!userInfo && !userInfoBeh) return;
        let colors = ["#00aeef", "#C95A49"];
        var pointBackgroundColors = ['black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black', 'black'];
        let datasets = [], datasetsBeh = [];
        for (let i = 0; i < this.skillData.length; i++) {

            //set skill data for showing in graph
            let skillName = this.skillData[i].skillName;
            let skillDataArray = this.getSkillResult(userInfo[skillName]);
            this.curRating["f_" + this.skillData[i].skillId] = skillDataArray[4];

            let skillObj = { fill: true, borderWidth: 3 };

            skillObj['data'] = this.makeArrayForGraph(this.skillData[i].skillId, "fun").slice(8);
            skillObj['label'] = "Competency Level"; //skillName + " - Actual Level";
            skillObj['backgroundColor'] = colors[0];
            skillObj['fill'] = true;
            skillObj['borderColor'] = colors[0];
            skillObj['lineTension'] = 0;
            skillObj['pointBackgroundColor'] = pointBackgroundColors;
            datasets.push(skillObj);
            //set intervention data for showing in graph
            let skillInterData = this.getSkillResult(userInfo[skillName + "InterData"]);
            let InterData = { fill: true, borderWidth: 3 };
            InterData['data'] = skillInterData;
            InterData['label'] = "Intervention"; //skillName + " - Planned Interventions";
            InterData['backgroundColor'] = colors[1];
            InterData['fill'] = true;
            InterData['borderColor'] = colors[1]; //i+1
            InterData['lineTension'] = 0;
            InterData['pointBackgroundColor'] = pointBackgroundColors;
            datasets.push(InterData);
        }

        for (let i = 0; i < this.skillBehData.length; i++) {
            //set skill data for showing in graph
            let skillName = this.skillBehData[i].skillName;

            let skillDataArray = this.getSkillResult(userInfoBeh[skillName]);

            this.curRating["b_" + this.skillBehData[i].skillId] = skillDataArray[4];

            let skillObj = { fill: true, borderWidth: 3 };
            
            skillObj['data'] = this.makeArrayForGraph(this.skillBehData[i].skillId, "beh").slice(8)

            skillObj['label'] = "Competency Level"; //skillName + " - Actual Level";
            skillObj['borderColor'] = colors[0];
            skillObj['backgroundColor'] = colors[0];
            skillObj['fill'] = true;
            skillObj['stacked'] = true;
            skillObj['lineTension'] = 0;
            skillObj['pointBackgroundColor'] = pointBackgroundColors;
            
            datasetsBeh.push(skillObj);
            //set intervention data for showing in graph
            let skillInterData = this.getSkillResult(userInfoBeh[skillName + "InterData"]);
            let InterData = { fill: true, borderWidth: 3 };
            InterData['data'] = skillInterData;
            InterData['label'] = "Intervention"; //skillName + " - Planned Interventions";
            InterData['borderColor'] = colors[1]; //i+1
            InterData['backgroundColor'] = colors[1];
            InterData['fill'] = true;
            InterData['stacked'] = true;
            InterData['lineTension'] = 0;
            InterData['pointBackgroundColor'] = pointBackgroundColors;
            datasetsBeh.push(InterData);
        }


        var options = {
            height: 400,
            legend: {
                display: true,
            },
            title: {
                display: true,
                fontSize: 12,
                fontFamily: "Century Gothic"
            },
            scales: {
                xAxes: [{
                    display: true
                }],
                yAxes: [{
                    display: true,
                    ticks: {
                        max: 5,
                        min: 0,
                        stepSize: 1
                    }
                }],
            }

        };

        var j = 0;
        for (let i = 0; i < datasets.length; i += 2) { //datasets.length
            this.chart = new Chart(divId.split("_")[0] + "_" + j++, {
                type: 'line',
                data: {
                    labels: this.totalMonth,
                    datasets: [datasets[i], datasets[i + 1]]
                },
                options: options
            });
        }

        var j = 0;
        for (let i = 0; i < datasetsBeh.length; i += 2) { //datasets.length
            this.chart = new Chart(divId.split("_")[0] + "_b_" + j++, {
                type: 'line',
                data: {
                    labels: this.totalMonth,
                    datasets: [datasetsBeh[i], datasetsBeh[i + 1]]
                },
                options: options
            });
        }

    }

    // Filter the result date based on date 
    private getSkillResult(data) {
        let dataArray = [];
        if (this.totalMonth.length > 0 && data && data.length) {
            for (let i = 0; i < this.totalMonth.length; i++) {
                for (let j = 0; j < data.length; j++) {
                    if (data[j].date == this.totalMonth[i]) {
                        dataArray.push(data[j].skillLevel); //skillLevel
                    }
                }
            }
        }
        return dataArray;
    }

    // get table canvas
    private getTableCanvas() {
        try {
            let canvasData = this.tableCanvas.nativeElement.querySelectorAll("tbody tr canvas");
            canvasData.forEach(canvas => {
                let index = canvas.id.split("_")[1];
                index = 0;
                let userInfo = this.resourceSkillsData[index];
                let userInfoBeh = this.resourceBehSkillsData[index];
                this.generateChart(canvas.id, userInfo, userInfoBeh);
            });

            $("select").on('change', (e) => {
                this.getTableCanvas();
            });
            $(".userRcCustomTable th").on('click', (e) => {
                this.getTableCanvas();
            });
            $(".dataTables_paginate").on('click', (e) => {
                this.getTableCanvas();
            });
        } catch (error) {
           
            this.loading = false;
            return;
        }
        this.loading = false;
    }

    // update user skills 
    private onUpdateSkills(updateUserSkill) {
        if (this.updateUserSkillForm.invalid) {
            localStorage.setItem('errorMsg', "Please select all fields value");
            this.commonService.showerror();
            return;
        }
        this.loading = true;
        let userInfo = this.getUserInfo(updateUserSkill.userName);
        userInfo.joinDate = this.common.getDatesYYMMDD(userInfo.joinDate);
        userInfo.updatedByEmail = this.users.userData.emailAddress;
        userInfo.selectedStoryLine = updateUserSkill.selectedStoryLine;
        userInfo.selectedLectora = updateUserSkill.selectedLectora;
        userInfo.selectedHTML = updateUserSkill.selectedHTML;
        let userSkill = this.setUserSkillData(updateUserSkill, userInfo.userId);
        this.commonService.updationResouceSkills(userInfo, userSkill).pipe(first()).subscribe(
            data => {
                this.loading = false;
                localStorage.setItem('errorMsg', data.status);
                this.commonService.showerror();
                setTimeout(function () {
                    window.location.reload();
                }, 500);
            },
            error => {
                this.loading = false;
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
            })

    }

    // Get user info based on user name
    private getUserInfo(userId) {
        let userInfo = null;
        if (this.currentUserList && this.currentUserList.length > 0) {
            for (let i = 0; i < this.currentUserList.length; i++) {
                if (userId == this.currentUserList[i].userId) {
                    userInfo = this.currentUserList[i];
                    break;
                }
            }
        }
        return userInfo;
    }

    //set user skill data
    private setUserSkillData(userFormDetails: any, userId: any) {
        let userSkillData = [];
        userSkillData.push({ userId: userId, skillId: Number(1), skillLevel: userFormDetails.selectedStoryLine });
        userSkillData.push({ userId: userId, skillId: Number(2), skillLevel: userFormDetails.selectedLectora });
        userSkillData.push({ userId: userId, skillId: Number(3), skillLevel: userFormDetails.selectedHTML });
        return userSkillData;
    }

    //save user interventions 
    private saveUserInterventions(interventionForm) {
        let userIntervention = [];
        this.loading = true;
        let userInfo = this.getUserInfo(this.currentUserId);
        let skillInfo = this.getUserskillInfo(interventionForm.userName);
        if (interventionForm && interventionForm.interventionFieldArray.length > 0) {
            let feildsArray = interventionForm.interventionFieldArray;
            for (let i = 0; i < feildsArray.length; i++) {
                let obj = {};
                if (this.validateFeild(feildsArray[i].actualLevel)) {
                    this.loading = false;
                    localStorage.setItem('errorMsg', "Please select current competency!");
                    this.commonService.showerror();
                    break;
                }
                if (this.validateFeild(feildsArray[i].interventionId)) {
                    this.loading = false;
                    localStorage.setItem('errorMsg', "Please select intervention type!");
                    this.commonService.showerror();
                    break;
                }
                if (feildsArray[i].interventionId) {
                    obj["interventionId"] = Number(feildsArray[i].interventionId);
                    obj["interventionType"] = this.getInterventionName(Number(feildsArray[i].interventionId));
                }

                if (this.validateFeild(userInfo.userId)) {
                    this.loading = false;
                    localStorage.setItem('errorMsg', "User not found!");
                    this.commonService.showerror();
                    break;
                }
                if (userInfo.userId) {
                    obj["userId"] = userInfo.userId;
                    obj["userName"] = userInfo.userName;
                    obj["userEmail"] = "Niit-emanuel.joseph@niit.com";//userInfo.email;
                }

                if (this.validateFeild(feildsArray[i].skillId)) {
                    this.loading = false;
                    localStorage.setItem('errorMsg', "Please select competency name!");
                    this.commonService.showerror();
                    break;
                }
                if (feildsArray[i].skillId) {
                    obj["skillId"] = feildsArray[i].skillId;
                    obj["skillName"] = this.getSkillNameById(feildsArray[i].skillId);
                }
                


                if (this.validateFeild(feildsArray[i].expectedLevel)) {
                    this.loading = false;
                    localStorage.setItem('errorMsg', "Please select competency level!");
                    this.commonService.showerror();
                    break;
                }
                if (feildsArray[i].expectedLevel) {
                    obj["expectedLevel"] = feildsArray[i].expectedLevel; //this.getSkillName(feildsArray[i].expectedLevel);
                }

                if (feildsArray[i].actualLevel) {
                    obj["actualLevel"] = feildsArray[i].actualLevel; //this.getSkillName(feildsArray[i].expectedLevel);
                }

                if (this.validateFeild(feildsArray[i].interventionStartDate)) {
                    this.loading = false;
                    localStorage.setItem('errorMsg', "Please select start date!");
                    this.commonService.showerror();
                    break;
                }

                if (feildsArray[i].interventionStartDate) {
                    obj["interventionStartDate"] = this.common.getDateYYMMDD(feildsArray[i].interventionStartDate);
                }

                if (this.validateFeild(feildsArray[i].interventionEndDate)) {
                    this.loading = false;
                    localStorage.setItem('errorMsg', "Please select end date!");
                    this.commonService.showerror();
                    break;
                }

                if (feildsArray[i].interventionEndDate) {
                    obj["interventionEndDate"] = this.common.getDateYYMMDD(feildsArray[i].interventionEndDate);
                }

                obj["createdBy"] = this.users.userData.displayName;
                obj["createdByEmail"] = this.users.userData.emailAddress;

                let validDate = this.validateAlignIntervention(obj["interventionStartDate"], feildsArray[i].savedInterventionId);
                if (!validDate) {
                    this.loading = false;
                    localStorage.setItem('errorMsg', userInfo.userName + " already planned for intervention at selected date!");
                    this.commonService.showerror();
                    break;
                }
                if (feildsArray[i].savedInterventionId) {
                    obj["savedInterventionId"] = feildsArray[i].savedInterventionId;
                }
                userIntervention.push(obj);
            }
        }
        this.commonService.saveUserInterventions(userIntervention).pipe(first()).subscribe(
            data => {
                this.loading = false;
                localStorage.setItem('errorMsg', data.status);
                this.commonService.showerror();
                setTimeout(function () {
                    window.location.reload();
                }, 500);
            },
            error => {
                this.loading = false;
                localStorage.setItem('errorMsg', error.statusText);
                this.commonService.showerror();
            });
    }

    // Get user info based on user name
    private getUserskillInfo(userName) {
        let userInfo = null;
        if (this.resourceSkillsData && this.resourceSkillsData.length > 0) {
            for (let i = 0; i < this.resourceSkillsData.length; i++) {
                if (userName.trim() == this.getUserName(this.resourceSkillsData[i].userId).trim()) {
                    userInfo = this.resourceSkillsData[i];
                    break;
                }
            }
        }
        return userInfo;
    }
    //validate align intervention
    private validateAlignIntervention(starDate, userInterventionId) {
        let validDate = true;
        if (this.userInterventionList && this.userInterventionList.length > 0) {
            if (starDate) {
                for (let i = 0; i < this.userInterventionList.length; i++) {
                    if (Number(userInterventionId) != Number(this.userInterventionList[i].userInterventionId)) {
                        starDate = new Date(starDate);
                        let intStartDate = new Date(this.userInterventionList[i].interventionStartDate);
                        let intEndDate = new Date(this.userInterventionList[i].interventionEndDate);
                        if (starDate >= intStartDate && starDate <= intEndDate) {
                            validDate = false;
                            break;
                        }
                    }
                }
            }
        }
        return validDate;
    }

    //get user interventions
    private getUserInterventions(userId) {
        
        let userInfo = this.getUserInfo(userId);
        this.userName = userInfo.userName;
        this.loading = true;
        this.userInterventionList = [];
        this.commonService.getUserInterventions(userInfo.userId).pipe(first()).subscribe(
            data => {
                this.currentUserId = userId;
                this.loading = false;
                this.userInterventionList = data;
            },
            error => {
                this.loading = false;
                localStorage.setItem('errorMsg', error);
                this.commonService.showerror();
            })
    }

    //get intervention name by intervention id
    private getInterventionName(interventionId) {
        let interventionType = "";
        if (this.interventionList && this.interventionList.length > 0) {
            for (let i = 0; i < this.interventionList.length; i++) {
                if (this.interventionList[i].internventionId == interventionId) {
                    interventionType = this.interventionList[i].interventionType;
                    break;
                }
            }
        }
        return interventionType;
    }

    // get user name by userId
    private getUserName(userId) {
        let userName = "";
        if (this.currentUserList && this.currentUserList.length > 0) {
            for (let i = 0; i < this.currentUserList.length; i++) {
                if (userId == this.currentUserList[i].userId) {
                    userName = this.currentUserList[i].userName;
                    break;
                }
            }
        }
        return userName;
    }

    // get user name by userId
    private getResourceType(userId) {
        let typeResource = "";
        if (this.currentUserList && this.currentUserList.length > 0) {
            for (let i = 0; i < this.currentUserList.length; i++) {
                if (userId == this.currentUserList[i].userId) {
                    typeResource = this.currentUserList[i].typeResource;
                    break;
                }
            }
        }
        return typeResource;
    }

    

    // get skill name by skillId
    private getSkillNameById(skillId) {
        let skillName = "";
        let allSkills = this.skillData;
        if (allSkills && allSkills.length > 0) {
            for (let i = 0; i < allSkills.length; i++) {
                if ("f_" + allSkills[i].skillId == skillId) {
                    skillName = allSkills[i].skillName;
                    return skillName;
                }
            }
        }

        allSkills = this.skillBehData;
        if (allSkills && allSkills.length > 0) {
            for (let i = 0; i < allSkills.length; i++) {
                if ("b_" + allSkills[i].skillId == skillId) {
                    skillName = allSkills[i].skillName;
                    return skillName;
                }
            }
        }

    }

    //edit Skill and and disable button
    private editSkill(event, skillObj) {
        event.target.offsetParent.disabled = true;
        this.f.savedInterventionId.setValue(skillObj.userInterventionId);
        this.f.skillId.setValue(skillObj.skillId);
        this.f.actualLevel.setValue(skillObj.actualLevel);
        this.f.interventionId.setValue(skillObj.interventionId);
        this.f.expectedLevel.setValue(skillObj.expectedLevel);
        this.f.interventionStartDate.setValue(this.common.getJSONObj(skillObj.interventionStartDate));
        this.f.interventionEndDate.setValue(this.common.getJSONObj(skillObj.interventionEndDate));
        
    }

    // validate feilds data is empty or blank
    private validateFeild(feildData) {
        if (!feildData) {
            return true;
        }
        return false;
    }

    //set end dates
    private setStartDate() {
        let date = new Date();
        this.config.minDate = { year: date.getFullYear() - 10, month: date.getMonth(), day: date.getDate() };
    }

    //set end dates
    private setEndDate(index) {
        let startDate = this.interventionForm.value.interventionFieldArray[index].interventionStartDate;
        if (startDate) {
            var dd = startDate.day + 1;
            var mm = startDate.month;
            var yy = startDate.year;
            this.config.minDate = { year: yy, month: mm, day: dd };
        } else {
            localStorage.setItem('errorMsg', 'Please select Start Date');
            this.commonService.showerror();
            return;
        }
    }

    // forward next section
    private gotoNextPage(e, routeURL) {
        this.router.navigate([routeURL]);
    }

    // logout and forward login page
    private logout() {
        localStorage.clear();
        this.commonService.logout();
    }

    // functions for show  and hide intervention graph tab by user clicked on respective buttons
     funClick() {
        this.funClicked = true;
        this.behClicked = false;
    }
     behClick() {
        this.funClicked = false;
        this.behClicked = true;
    }

    private getInterventionListClick(skillid, index) {
        let allSkills = this.skillData;
        const interv = this.commonInterventionData.find((obj) => obj.skillId === skillid);
        this.currentSkillIntervention = interv;
        this.interventionList = JSON.parse(interv.arrOfTraining);
    }
    /**
     * Get all skill of user according to towerId and positionId
     */
    private userBehSkillByTowerPosition() {
        this.commonInterventionData = [];
        this.selectedUserId = this.selectedCombinedId.split("_")[0];
        this.selectedPositionId = this.selectedCombinedId.split("_")[1];
        const postData = { userId: this.selectedUserId, positionId: this.selectedPositionId, towerId: this.selectedTowerId };
        this.commonService.getBehUserSkill(postData).pipe(first()).subscribe(
            data => {
                this.commonInterventionData = data;
            },
            error => {
                this.loading = false;
            }
        );
    }
    /**
     * Get Functional skill of user according to towerId and positionId
     */
    private userFunSkillByTowerPosition() {
        this.commonInterventionData = [];
        this.selectedUserId = this.selectedCombinedId.split("_")[0];
        this.selectedPositionId = this.selectedCombinedId.split("_")[1];
        const postData = { userId: this.selectedUserId, positionId: this.selectedPositionId, towerId: this.selectedTowerId };
        this.commonService.getFunUserSkill(postData).pipe(first()).subscribe(
            data => {
                this.commonInterventionData = data;
            },
            error => {
                this.loading = false;
            }
        );
    }
    /**
     * Get intervention name
     * @param interventionId
     */
    public getInterventionNameById(interventionId) {
        if (interventionId) {
            const interventions = this.interventionList.find((obj) => Number(obj.id) === Number(interventionId));
            if (interventions) {
                return interventions.trainingPoint;
            } else { return null; }
        }
    }
}